import { api } from '@/lib/axios';

export interface Branch {
    id: string;
    name: string;
    address: string | null;
    phone: string | null;
    afipPointOfSale: number | null;
    mpPointTerminalId: string | null;
    isActive: boolean;
    createdAt: string;
    updatedAt: string;
}

export type CurrentBranch = Pick<Branch, 'id' | 'name' | 'address' | 'phone'>;

export interface BranchInput {
    name: string;
    address?: string | null;
    phone?: string | null;
    afipPointOfSale?: number | null;
    mpPointTerminalId?: string | null;
    isActive?: boolean;
}

export const branchesApi = {
    /** Solo admin */
    getAll: async () => (await api.get<Branch[]>('/api/branches')).data,
    /** Cualquier usuario: el local donde está trabajando */
    getCurrent: async () => (await api.get<CurrentBranch | null>('/api/branches/current')).data,
    create: async (data: BranchInput) => (await api.post<Branch>('/api/branches', data)).data,
    update: async (id: string, data: Partial<BranchInput>) => (await api.patch<Branch>(`/api/branches/${id}`, data)).data,
};
